import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PetSafeProduct} from '@model/product/product.model';
import {User} from '@model/user/user.model';
import {UserProduct} from '@model/user/user-product.model';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit, OnChanges {

  @Input()
  selectedProduct: PetSafeProduct;

  @Input()
  user: User;

  mSelectedUserProduct: UserProduct;

  get selectedUserProduct() {
    return this.mSelectedUserProduct;
  }

  set selectedUserProduct(val) {
    this.mSelectedUserProduct = val;
    this.selectedUserProductChanged.emit(val);
  }

  @Output()
  selectedUserProductChanged: EventEmitter<any> = new EventEmitter<any>();

  email: string;
  thingName: string;
  productType: string;
  firmware: string;

  constructor() { }

  ngOnInit() {
  }

  selectProduct() {
    if (this.selectedUserProduct) {
      this.thingName = this.selectedUserProduct.entityId;
      this.productType = this.selectedUserProduct.entityData.productType;
      this.firmware = 'TODO';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.user) {
      this.email = this.user.email;
    }
  }
}
